import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { LoanApplicationWizard } from '../components/LoanApplicationWizard';
export function ApplyPage() {
  return <div className="min-h-screen bg-offwhite font-sans text-navy" data-id="element-563">
      <Navbar data-id="element-564" />
      <main className="pt-24 pb-16" data-id="element-565">
        <div className="container mx-auto px-4 text-center mb-10" data-id="element-566">
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-4" data-id="element-567">
            Loan Application
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-568">
            Complete the form below to apply for a loan. It only takes a few
            minutes, and we'll get back to you within 24 hours.
          </p>
        </div>
        <LoanApplicationWizard data-id="element-569" />
      </main>
      <Footer data-id="element-570" />
    </div>;
}